
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../assets/images/logo.png";
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../components/CustomComponent.js";

import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            data: []
        }
    }
    async componentDidMount() {
        this.Get();
    }

    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            job_id: ""
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data: result.data });
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="แดชบอร์ด" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between test">
                            <h3 className="mb-2"><b>หน้าหลัก</b></h3>
                        </div>
                        <div className="row">
                            {/* นัดเข้าซ่อมวันนี้ */}
                            <div className="col-12 col-sm-6 col-md-6 col-lg-4 mb-2">
                                <div className="card bg-blue text-white border-0 px-3 py-2 w-100 rounded-lg">
                                    <div className="row">
                                        <div className="col-8 col-lg-6 py-2">
                                            <div className="d-flex align-items-end justify-content-between">
                                                <small>นัดเข้าซ่อมวันนี้</small>
                                                <h4 className="mb-0">{this.state.data.filter(item => item.job_status === 1 && format_date(item.repair_date) === format_date(new Date())).length} <span>คัน</span></h4>
                                            </div>
                                            <hr className="mt-2 mb-1 bg-white" style={{ height: 2 }} />
                                            <div className="d-flex align-items-end justify-content-between">
                                                <small>รับเข้าซ่อมวันนี้</small>
                                                <h4 className="mb-0">{this.state.data.filter(item => item.job_status === 2 && format_date(item.repair_date) === format_date(new Date())).length} <span>คัน</span></h4>
                                            </div>
                                        </div>
                                        <div className="col-4 col-lg-6 py-2">
                                            <div className="d-flex align-items-end justify-content-end">
                                                <h1 className="mb-0"><b>{this.state.data.filter(item => (item.job_status === 1 || item.job_status === 2) && format_date(item.repair_date) === format_date(new Date())).length}</b></h1>
                                                <span className="ms-2 icon text-24">{"\uf1b9"}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* ยังไม่เปิดงานซ่อม */}
                            <div className="col-12 col-sm-6 col-md-6 col-lg-4 mb-2">
                                <div className="card bg-teal text-white border-0 px-3 py-2 w-100 rounded-lg">
                                    <div className="row">
                                        <div className="col-8 col-lg-6 py-2">
                                            <div className="d-flex align-items-end justify-content-between">
                                                <small>ยังไม่เปิดงานซ่อม</small>
                                                <h4 className="mb-0">{this.state.data.filter(item => item.job_status === 1 || item.job_status === 2).length} <span>คัน</span></h4>
                                            </div>
                                            <hr className="mt-2 mb-1 bg-white" style={{ height: 2 }} />
                                            <div className="d-flex align-items-end justify-content-between">
                                                <small>เปิดงานซ่อมแล้ว</small>
                                                <h4 className="mb-0">{this.state.data.filter(item => item.job_status === 4).length} <span>คัน</span></h4>
                                            </div>
                                        </div>
                                        <div className="col-4 col-lg-6 py-2">
                                            <div className="d-flex align-items-end justify-content-end">
                                                <h1 className="mb-0"><b>{this.state.data.filter(item => item.job_status === 1 || item.job_status === 2 || item.job_status === 4).length}</b></h1>
                                                <span className="ms-2 icon text-24">{"\uf1b9"}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* นัดส่งคืนรถวันนี้ */}
                            <div className="col-12 col-sm-12 col-md-12 col-lg-4 mb-2">
                                <div className="card bg-orange text-white border-0 px-3 py-2 w-100 rounded-lg">
                                    <div className="row">
                                        <div className="col-8 col-lg-6 py-2">
                                            <div className="d-flex align-items-end justify-content-between">
                                                <small>นัดส่งคืนรถวันนี้</small>
                                                <h4 className="mb-0">{this.state.data.filter(item => item.job_status === 4 && format_date(item.complete_date) === format_date(new Date())).length} <span>คัน</span></h4>
                                            </div>
                                            <hr className="mt-2 mb-1 bg-white" style={{ height: 2 }} />
                                            <div className="d-flex align-items-end justify-content-between">
                                                <small>ส่งคืนรถแล้ววันนี้</small>
                                                <h4 className="mb-0">{this.state.data.filter(item => item.job_status === 5 && format_date(item.complete_date) === format_date(new Date())).length} <span>คัน</span></h4>
                                            </div>
                                        </div>
                                        <div className="col-4 col-lg-6 py-2">
                                            <div className="d-flex align-items-end justify-content-end">
                                                <h1 className="mb-0"><b>{this.state.data.filter(item => (item.job_status === 4 || item.job_status === 5) && format_date(item.complete_date) === format_date(new Date())).length}</b></h1>
                                                <span className="ms-2 icon text-24">{"\uf1b9"}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* ลูกค้าติดต่องานวันนี้ */}
                            <div className="col-12 col-md-6 mb-2">
                                <div className="card border-0 rounded-lg">
                                    <div className="card-header bg-primary rounded-top-lg">
                                        <div className="w-100 d-flex align-items-center justify-content-between flex-wrap">
                                            <h5 className="text-white mb-0"><b>ลูกค้าติดต่องานวันนี้ : {this.state.data.filter(item => item.job_status === 1 && format_date(item.repair_date) === format_date(new Date())).length}</b></h5>
                                            <div className="wpx-130">
                                                <DatePicker
                                                    className="form-control bg-white border-0"
                                                    placeholder="พิมพ์คำค้นหา..."
                                                    onChange={(e) => {
                                                        this.setState({ filter_transfer_date: e });
                                                    }}
                                                    value={this.state.filter_transfer_date}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive pb-5" style={{ height: 450 }}>
                                            <table className="table table-borderless table-striped table-hover">
                                                <tbody>
                                                    {this.state.data && this.state.data.filter(item => item.job_status === 1 && format_date(item.repair_date) === format_date(new Date())).map((item, index) => (
                                                        <tr className="pointer" key={index} onClick={() => { window.location.href = "/manage-repair/repair/update?id=" + item.job_id }}>
                                                            <td className="text-center">
                                                                <div className="d-flex">
                                                                    <div className="wpx-30 hpx-30 rounded-circle bg-secondary me-3">
                                                                        <img src={LOGO} style={{ width: 30 }} />
                                                                    </div>
                                                                    {item.member_name ? item.member_name : "-"}
                                                                </div>
                                                            </td>
                                                            <td className="text-center">{item.job_number ? item.job_number : "-"}</td>
                                                            <td className="text-center">{item.license_plate ? item.license_plate : "-"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* นัดส่งคืนรถวันนี้ */}
                            <div className="col-12 col-md-6 mb-2">
                                <div className="card border-0 rounded-lg">
                                    <div className="card-header bg-primary rounded-top-lg">
                                        <div className="w-100 d-flex align-items-center justify-content-between flex-wrap">
                                            <h5 className="text-white mb-0"><b>นัดส่งคืนรถวันนี้ : {this.state.data.filter(item => item.job_status === 4 && format_date(item.complete_date) === format_date(new Date())).length}</b></h5>
                                            <div className="wpx-130">
                                                <DatePicker
                                                    className="form-control bg-white border-0"
                                                    placeholder="พิมพ์คำค้นหา..."
                                                    onChange={(e) => {
                                                        this.setState({ filter_transfer_date: e });
                                                    }}
                                                    value={this.state.filter_transfer_date}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive pb-5" style={{ height: 450 }}>
                                            <table className="table table-borderless table-striped table-hover">
                                                <tbody>
                                                    {this.state.data && this.state.data.filter(item => item.job_status === 4 && format_date(item.complete_date) === format_date(new Date())).map((item, index) => (
                                                        <tr className="pointer" key={index} onClick={() => { window.location.href = "/manage-repair/repair/update?id=" + item.job_id }}>
                                                            <td className="text-center">
                                                                <div className="d-flex">
                                                                    <div className="wpx-30 hpx-30 rounded-circle bg-secondary me-3">
                                                                        <img src={LOGO} style={{ width: 30 }} />
                                                                    </div>
                                                                    {item.member_name ? item.member_name : "-"}
                                                                </div>
                                                            </td>
                                                            <td className="text-center">{item.job_number ? item.job_number : "-"}</td>
                                                            <td className="text-center">{item.license_plate ? item.license_plate : "-"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
